import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {DokumentSignatarModell, LitenIkkeTomStreng} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {EnumPipe} from "felles-ng2/pipes/EnumPipe";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {TranslateModule} from "@ngx-translate/core";
import {MatInput} from "@angular/material/input";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";

const debug = initDebugger('SigneringBekreftSlettSignaturerKomponent');

/**
 * Dialog for bekreftelse av signaturer
 */
@Component({
    selector: 'signering-bekreft-slett-signaturer-dialog',
    templateUrl: 'signering-bekreft-slett-signaturer-dialog.html',
    styleUrl: 'signering-bekreft-slett-signaturer-dialog.scss',
    imports: [
        EnumPipe,
        FormaterZonedDateTimePipe,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatFormField,
        MatLabel,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        MatInput,
        TipsKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SigneringBekreftSlettSignaturerDialogKomponent {

    static vis(dialog: MatDialog, signaturer: DokumentSignatarModell[]) {
        return dialog.open<SigneringBekreftSlettSignaturerDialogKomponent, DialogParametre, SigneringBekreftSlettSignaturerDialogRespons>(SigneringBekreftSlettSignaturerDialogKomponent,
          {
              data: {signaturer} as DialogParametre,
              disableClose: true,
              maxWidth: 600
          });
    }

    signaturer: DokumentSignatarModell[];

    aarsak = new FormControl<LitenIkkeTomStreng>('', {nonNullable: true, validators: FeltValidatorer.litenIkkeTomStreng});

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<SigneringBekreftSlettSignaturerDialogKomponent, SigneringBekreftSlettSignaturerDialogRespons>) {
        this.signaturer = parametre.signaturer;
    }

    avbryt() {
        this.dialogRef.close({utfør: false});
    }

    utfoer() {
        this.dialogRef.close({årsak: this.aarsak.value, utfør: true});
    }
}


export type SigneringBekreftSlettSignaturerDialogRespons = { utfør: true; årsak: LitenIkkeTomStreng; } | { utfør: false; };

export type DialogParametre = { signaturer: DokumentSignatarModell[]; };
